module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-1-bb96ecf8.png";